
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';
import { WorkProjectdossierDocumentselectionEntryDto } from '../models/work-projectdossier-documentselection-entry-dto';

export function getCreateProjectdossierTemplateDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    assignToNewProjects: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    assignToExistingProjects: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    assignFromDate: new FormControl<string | undefined>(undefined),
    roletypeIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
    documentselection: new FormControl<WorkProjectdossierDocumentselectionEntryDto[]>([]),
    sortOrder: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    visibleForExternalAccessDefault: new FormControl<boolean | undefined>(false),
})
;
}
      